/**
 * The result of calling Ensure on the API.
 * @export EnsureOperationResult
 * @class EnsureOperationResult
 */
export default class EnsureOperationResult {

    /**
     * Creates an instance of a EnsureOperationResult.
     * @param {EnsureOperationResultSourceData} data Source data object.
     * @memberof EnsureOperationResult
     */
    constructor(data = null) {

        /**
         * @type {Array<string>}
         */
        this.errors = data && data.messages.errors ? data.messages.errors : []

        /**
         * @type {Array<string>}
         */
        this.warnings = data && data.messages.warnings ? data.messages.warnings : []

        /**
         * @type {boolean}
         */
        this.calcNeeded = data && data.calcNeeded ? data.calcNeeded : false

        /**
         * @type {boolean}
         */
        this.success = data && data.messages.errors.length === 0
    }
}
